/**
 * brandAssets: canonical RILE Connect logo asset paths.
 */

export const RILE_MARK_URL = '/images/brand/node-star-black-edges.png';

// Horizontal lockup (mark + wordmark, no tagline), navy text/edges, for
// light backgrounds. This is the platform apex's brand rendering in the
// navbar and footer, replacing a separate icon + text span with one image
// so the mark and wordmark are both on-brand together.
export const RILE_HORIZONTAL_LOGO_URL =
    '/images/brand/horizontal-logo-without-tag-blue.png';

// Horizontal lockup WITH the "ECOSYSTEM OF ECOSYSTEMS" tagline, navy
// text/edges, for light backgrounds. Larger-format marketing placements
// (e.g. the apex hero) use the full lockup; the navbar/footer use the
// tagline-free variant above since there isn't room for the tagline at
// that size.
export const RILE_HORIZONTAL_LOGO_WITH_TAG_URL =
    '/images/brand/horizontal-logo-blue-text.png';

/**
 * Resolve a tenant's own authored logo. The RILE mark must never stand in
 * for an ecosystem's own missing logo (that misrepresents the tenant as
 * RILE Connect itself) - a tenant with no authored logo gets no image at
 * all, name text only. The platform apex has its own RILE-branded
 * rendering (RILE_HORIZONTAL_LOGO_URL) and never calls this.
 *
 * @param {object} ecosystem - Active Ecosystem record.
 * @returns {string|null} An image URL, or null when nothing should render.
 */
export function getTenantLogoUrl(ecosystem) {
    return ecosystem?.branding?.logoUrl || null;
}

export default getTenantLogoUrl;
